import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DictionaryRecord } from '@backrs_ui/common-ui';

import { fetchDataDictionary } from './thunks/dataDictionary.thunk';

type DataDictionaryDataState = Readonly<{
  dataDictionary: DictionaryRecord | null;
  loading?: boolean;
  error?: string;
}>;

const initialState: DataDictionaryDataState = {
  dataDictionary: null,
  loading: false,
  error: undefined,
};

export const dataDictionarySlice = createSlice({
  name: 'dataDictionarySlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataDictionary.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchDataDictionary.fulfilled, (state, action: PayloadAction<DictionaryRecord>) => {
        state.dataDictionary = action.payload;
        state.loading = false;
      })
      .addCase(fetchDataDictionary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});
